import { OrganizationContext } from "hhn-commons";
import React, { useContext, useMemo } from "react";
import {
  IChatListFilters,
  IDepartmentData,
  SERVICE_STATUS,
} from "@home-health-notify/domain";
import { ServicesToPatientText } from "./Common.style";
import PatientHomeIcon from "./PatientHomeIcon";
import {
  FilterBy,
  SelectedFilterListItem,
  SelectedFilterListWrapper,
} from "./SelectedFilters.style";

const filterBy = {
  UNREAD: "Unread",
  PENDING_REFERRAL: "Pending Referrals",
  DATE: "",
};

const SelectedChatListFilters = ({
  filters,
  filterCount,
}: {
  filters: IChatListFilters;
  filterCount: number;
}) => {
  const { selectedOrgUser } = useContext(OrganizationContext);
  const departments: IDepartmentData[] | undefined =
    selectedOrgUser?.getDepartments();

  const serviceToPatient = useMemo(
    () =>
      Array.isArray(filters?.servicesToPatient) &&
      filters.servicesToPatient.length > 0 &&
      (departments || []).find(
        department => department.id === filters.servicesToPatient?.[0]?.id,
      ),
    [filters, departments],
  );

  return (
    filterCount > 0 && (
      <SelectedFilterListWrapper>
        {Array.isArray(filters.patientStatus) &&
          filters.patientStatus.length > 0 && (
            <SelectedFilterListItem>
              {filters.patientStatus.map(status => (
                <PatientHomeIcon
                  key={status}
                  size={20}
                  status={status}
                />
              ))}
            </SelectedFilterListItem>
          )}
        {serviceToPatient &&
          Array.isArray(filters.servicesToPatient) &&
          filters.servicesToPatient.length > 0 && (
            <SelectedFilterListItem>
              <ServicesToPatientText
                variant="body2"
                status={filters.servicesToPatient[0]?.status as SERVICE_STATUS}
              >
                {serviceToPatient.shortHand}
              </ServicesToPatientText>
            </SelectedFilterListItem>
          )}
        {filters.filterBy &&
          filterBy[filters.filterBy as keyof typeof filterBy] && (
            <SelectedFilterListItem>
              <FilterBy>
                {filterBy[filters.filterBy as keyof typeof filterBy]}
              </FilterBy>
            </SelectedFilterListItem>
          )}
      </SelectedFilterListWrapper>
    )
  );
};

export default SelectedChatListFilters;
